@import 'styles/mixins';
@import 'styles/variables';

// TODO: De-dupe from Button.module.scss
.buttonActive {
  color: $blue-50;
  background: $blue-10;

  &:hover {
    background: $blue-20;
  }

  .icon {
    // Per https://codepen.io/sosuke/pen/Pjoqqp
    filter: invert(41%) sepia(52%) saturate(748%) hue-rotate(162deg) brightness(95%) contrast(87%);
  }
}

.chevron {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $grey-40;
}

.icon {
  background-size: 100%;
  min-width: 226px;
  min-height: 27px;
  margin: 4.5px 0;
}

.searchInput {
  color: $grey-40;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.01em;
  cursor: pointer;
  background-color: transparent;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.inputSvgWrapper {
  display: flex;
}
.inputSvgWrapperSmall {
  display: block;
  overflow: hidden;
  width: 98px;
  height: 28px;
}
.dots {
  margin-left: 2px;
}

.mainButton,
.familyButton,
.weightButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $grey-40;

  [data-autopilot-system-redesign='on'] & {
    background: transparent !important;
    box-shadow: none !important;

    &:hover {
      background: var(--dark-3) !important;
    }

    &.active {
      background: var(--dark-8) !important;
    }
  }
}
.familyButton,
.weightButton {
  border-radius: 4px;
}
// TODO: De-dupe from SimpleDropdown.module.scss
.dropdownBody {
  display: flex;
  flex-direction: column;
  position: absolute;
  background: var(--neutral-0);
  z-index: 105; // Had to make this higher to go over TabSelector_container
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(19, 21, 26, 0.12);
  padding: 4px;
  max-height: 80vh;
  overflow-y: auto;
  width: 250px;
}

.isSubmenuBody {
  max-height: 50vh;
  overflow-y: auto;
  width: 250px;
}
